import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "material-ui-snackbar-provider";
import {
  Row,
  Col,
  Accordion,
  Card,
  useAccordionButton,
  AccordionContext,
  Modal,
  Spinner,
} from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";
import countryList from "country-list";
import countries from "i18n-iso-countries";
import {
  calculateEffortRate,
  getCustomIncome,
  getIncomeForEffortRate,
  haveValue,
  nl2ul,
  showTickOnDoc,
} from "../../../helper/common";
import { toast } from "react-toastify";
import { MdInfoOutline, MdOutlineHistory } from "react-icons/md";
import AuthContext from "../../../context/auth/AuthContext";
import TenantContext from "../../../context/tenant/TenantContext";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { RiDownloadLine } from "react-icons/ri";
import { VscEye } from "react-icons/vsc";
import constants from "../../../Utils/constants";
import LandLordContext from "../../../context/landlord/LandLordContext";
import ProfileInfoSection from "../../../components/TenantHome/ProfileInfoSection";
import ProfessionalAcademicSection from "../../../components/TenantHome/ProfessionalAcademicSection";
import SummarySection from "../../../components/TenantHome/SummarySection";
import axiosInstance from "../../../services/authWrapper";
import LandlordBlurApprove from "../../../components/Landlord/LandlordBlurApprove";
import ProfileScore from "../../../components/Tenant/ProfileScore";
import EffortRateBar from "../../../components/Landlord/EffortRateBar";
import RentPercSlider from "../../../components/Landlord/RentPercSlider";
import DefaulterCheck from "../../../components/TenantHome/DefaultCheck";
import CombinedIncome from "../../../components/Landlord/CombinedIncome";
import DocHistoryPopup from "../../../components/Property/DocHistoryPopup";
import { LuDownload } from "react-icons/lu";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const UserScoreProfile = (props) => {
  const {
    properties,
    defaultPropertyLink,
    propList,
    selectBtn,
    handlePropSelect,
    handleLinkProperty,
    propertyLink,
    currentActiveAccordion,
    fullinfo,
    setCurrentActiveAccordion,
    handleUnlinkProperty,
    rentPercentage = 0,
    setRentPercentage,
    rent_from_income,
    sharedProfileProp,
    loadFullInfo,
    isGuarantor = false,
    fullInfoForGurantor,
  } = props;
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user: landlord_user, loadUser, setLoading } = authContext;
  const landLordContext = useContext(LandLordContext);
  const { saveRentPercentage } = landLordContext;
  const user = props?.scoreProfile;
  const navigate = useNavigate();
  const [ident_all, setIdent_all] = useState(false);
  const [linkedPropId, setLinkedPropId] = useState(false);
  const [tenantDocsDataOriginal, setTenantDocsDataOriginal] = useState([]);
  const [showExperianDetails, setShowExperianDetails] = useState(false);
  const [tenantDocsData, setTenantDocsData] = useState(null);
  const [ieScore, setIeScore] = useState(0);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryData, setSummaryData] = useState("");
  const [effortObj, setEffortObj] = useState("");

  //extracting url parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const stepToGo = queryParameters.get("step");
  const error1 = queryParameters.get("error");
  const account_verification_report_id = queryParameters.get(
    "account_verification_report_id"
  );
  const transaction_report_id = queryParameters.get("transaction_report_id");
  const [genSummaryLoading, setGenSummaryLoading] = useState(false);
  const [docHistoryPopup, setDocHistoryPopup] = useState(false);
  const [selectedTypeForHistory, setSelectedTypeForHistory] = useState(null);
  const [showSpinner, setShowSpinner] = useState();

  useEffect(() => {
    if (haveValue(stepToGo)) {
      if (stepToGo == "linked_props") {
        document
          .getElementsByClassName("accordion-button collapsed")[2]
          .click();
      }
    }
  }, [stepToGo]);

  const [tenantDocsHistory, setTenantDocsHistory] = useState({});

  useEffect(() => {
    const tempMap = new Map(); // Tracks 'clave' types
    const typeMap = new Map(); // Latest doc per type (strictly by type)
    const otherDocs = []; // Docs with 'others' source
    const publicHousingMap = new Map(); // Latest doc per type for public housing
    const docHistoryMap = new Map(); // All docs grouped by type for history

    if (
      Array.isArray(tenantDocsDataOriginal) &&
      tenantDocsDataOriginal.length > 0
    ) {
      tenantDocsDataOriginal.forEach((doc) => {
        // Track 'clave' types
        if (doc?.from === "clave") {
          tempMap.set(doc.type, true);
        }

        // Keep latest doc per unique type for main display, excluding 'others'
        if (doc?.from !== constants.others) {
          const existingDoc = typeMap.get(doc.type);

          if (
            !existingDoc ||
            new Date(doc.created_at) > new Date(existingDoc.created_at)
          ) {
            typeMap.set(doc.type, doc);
          }
        }

        // Collect 'others' docs
        if (doc?.from === "others") {
          otherDocs.push(doc);
        }

        // Keep latest doc per type for public housing docs
        if (doc?.from === "public_housing_docs") {
          const existing = publicHousingMap.get(doc.type);
          if (
            !existing ||
            new Date(doc.created_at) > new Date(existing.created_at)
          ) {
            publicHousingMap.set(doc.type, doc);
          }
        }

        // Build document history map by type
        if (!docHistoryMap.has(doc.type)) {
          docHistoryMap.set(doc.type, []);
        }
        docHistoryMap.get(doc.type).push(doc);
      });

      // Sort history arrays descending (latest first)
      docHistoryMap.forEach((docsArray) => {
        docsArray.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
      });

      // Prepare final list for main display
      const publicHousingDocsSorted = Array.from(
        publicHousingMap.values()
      ).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      const publicHousingTypes = new Set(
        publicHousingDocsSorted.map((doc) => doc.type)
      );

      const filteredTypeMapDocs = Array.from(typeMap.values()).filter(
        (doc) => !publicHousingTypes.has(doc.type)
      );

      const finalDocs = [
        ...otherDocs,
        ...publicHousingDocsSorted,
        ...filteredTypeMapDocs,
      ];

      setTenantDocsData(finalDocs);
      setTenantDocsHistory(Object.fromEntries(docHistoryMap));
    }
  }, [tenantDocsDataOriginal]);

  useEffect(() => {
    //console.log("kyc page -----", account_verification_report_id);

    if (error1) {
      toast.error(_t("bankDetailsCannotBeFetched"));
    }
    if (account_verification_report_id && transaction_report_id) {
      // snackbar.showMessage(_t("Connected to Bank"));
      let userid = user?._id;
      if (!userid) {
        toast.error(_t("userNotAuthorized"));
      } else {
        //console.log("Calculate Score============>");
        calculateScore(
          userid,
          account_verification_report_id,
          transaction_report_id
        );
      }
    }
  }, [account_verification_report_id]);

  const enhancedOptions = [
    ...propList,
    {
      label: <CustomButton />,
      value: "button",
      isDisabled: true, // Prevents selection
    },
  ];

  function CustomButton() {
    return (
      <div
        className="w-full h-full "
        style={{
          width: "100%",
          position: "absolute",
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevents dropdown from closing
            navigate("/landlord/add-property"); // Navigate to a new page
          }}
          className="w-full h-full rounded text-center py-2"
        >
          {_t(
            "addNewProp",
            "In landlord side while linked properties select is open to add new prop"
          )}
        </button>
      </div>
    );
  }

  const calculateScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    //console.log("payment score calculations");
    // setBankDiv("kyc-loading");
    await clearPaymentData(userid);
    calculatePaymentScore(userid, accountverificationid, transactionreportid);
  };

  const clearPaymentData = async (tenantid) => {
    //console.log("Clearing Payment Data ===========>> ",);
    return new Promise((resolve) => {
      axiosInstance
        .delete(
          `${process.env.REACT_APP_SERVER_URL}/tenants/algoan-info?tenantid=${tenantid}`
        )
        .then((res) => {
          //console.log(res);
          //console.log("previous data cleared");
          return resolve(true);
        })
        .catch((err) => {
          let err_res = err;
          toast.error(err_res.message);
          return resolve(null);
        });
    });
  };

  const calculatePaymentScore = async (
    userid,
    accountverificationid,
    transactionreportid
  ) => {
    // setLoading(true)
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/calculatescore?tenantid=${userid}&accountverificationid=${accountverificationid}&transactionreportid=${transactionreportid}`
      )
      .then((res) => {
        let serverResponse = res.data;
        //console.log(serverResponse);
        if (serverResponse.status !== "success") {
          if (serverResponse.status == "pending") {
            loadUser(userType);
          } else {
            loadUser(userType);
          }
        }
        if (serverResponse.status === "success") {
          toast.success(_t("bankConnectedSuccessfully"));
          loadUser(userType);
          // setBankDiv("kyc-loaded");
        }
        // setLoading(false)
      })
      .catch((err) => {
        let err_res = err;
        // setLoading(false)
        //console.log(err_res);
      });
  };

  const alpha3ToName = (code) => {
    return countries.getName(code, "en");
  };
  const { userType } = authContext;

  const tenantContext = useContext(TenantContext);
  const {
    myRentedProperties,
    myPreviouslyRentedProperties,
    getKycDocs,
    kycuserinfo,
    fetchTenantDocs,
    getDocumentAnalysis,
    getZipDocs,
  } = tenantContext;

  const [userKycInfo, setUserKycInfo] = useState({});
  const [recordedSalary, setRecordedSalary] = useState({
    salary: 0,
    matched: 0,
  });
  const [haveGuarantor, setHaveGuarantor] = useState(false);

  useEffect(() => {
    loadOffers();
    if (!user?.analysisCompleted && user?.algoanAnalysis) {
      getAnalysisDetails();
    }

    myRentedProperties(user?._id);
    myPreviouslyRentedProperties(user?._id);

    if (!user?.onfido_kyc_success) {
      getKycReport(user?._id);
    }

    if (
      user?.have_gurantor == "no" ||
      user?.have_gurantor == null ||
      user?.haveGuarantor == false
    ) {
      setHaveGuarantor(false);
    } else {
      setHaveGuarantor(true);
    }

    fetchFileData();
  }, []);
  useEffect(() => {
    const temp_id = defaultPropertyLink.map((prop) => prop.value);

    setLinkedPropId(temp_id);
  }, [defaultPropertyLink]);

  useEffect(() => {
    checkSalary();
    getkycDetails();
  }, [kycuserinfo]);

  useEffect(() => {
    checkAllMatches();
    calculateIeScore();
  }, [user, userKycInfo]);

  const [userIncome, setUserIncome] = useState(null);
  const [gurantorsIncome, setGurantorsIncome] = useState([]);
  const [combinedIncome, setCombinedIncome] = useState(0);
  const [incomeSources, setIncomeSources] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const user_income_sources = isGuarantor
      ? fullInfoForGurantor?.income_selection
      : fullinfo?.income_selection;

    const gurantor_income_sources = user_income_sources?.guarantor_sources;

    setIncomeSources(user_income_sources);

    // user income
    const user_income = getCustomIncome(
      user,
      landlord_user,
      _t,
      isGuarantor
        ? gurantor_income_sources?.[user?._id]
        : user_income_sources?.tenant_source
    );
    setUserIncome(user_income);

    const updatedIncomeSource = {
      ...user_income_sources,
      tenant_source: user_income?.source || user_income_sources?.tenant_source,
    };

    setIncomeSources(updatedIncomeSource);

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = user?.gurantor_id;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncome(
            gurantor,
            landlord_user,
            _t,
            gurantor_income_sources?.[gurantor?._id]
          );
          // console.log("gurantor_income", income);
          totalGurantorIncome += income?.amount || 0;
          allGurantorIncomes.push(income);
        }
      });
    }
    setGurantorsIncome(allGurantorIncomes);

    const combinedIncome = +user_income?.amount + +totalGurantorIncome;
    setCombinedIncome(combinedIncome);
    // calculating effort rate.
    let temp_obj = calculateEffortRate(combinedIncome, landlord_user, fullinfo);
    setEffortObj(temp_obj);
  }, [user, fullinfo, fullInfoForGurantor]);

  const calculateIeScore = () => {
    var totalScore = (user?.paymentScores?.creditScore?.value || 0) / 2;

    if (user?.ie_verified && user?.is_university) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const checkSalary = () => {
    // if (haveValue(user?.gurantor_id)) {
    //   if (user?.gurantor_id?.algoanIncome) {
    //     let monthlyIncome = parseInt(
    //       user?.gurantor_id?.algoanIncome?.monthlyAmount
    //     );
    //     let recorded_annual_salary = monthlyIncome * 12;

    //     let userIncome = parseInt(
    //       haveValue(user?.gurantor_id?.current_annual_income)
    //         ? user?.gurantor_id?.current_annual_income
    //         : 0
    //     );
    //     let salaryMatch = Math.round(
    //       (recorded_annual_salary / userIncome) * 100
    //     );

    //     setRecordedSalary({
    //       ...recordedSalary,
    //       matched: salaryMatch,
    //       salary: recorded_annual_salary,
    //     });
    //   }
    // } else {
    if (user?.algoanIncome) {
      let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
      let recorded_annual_salary = monthlyIncome * 12;

      let userIncome = parseInt(
        haveValue(user.current_annual_income) ? user.current_annual_income : 0
      );
      let salaryMatch = Math.round((recorded_annual_salary / userIncome) * 100);

      setRecordedSalary({
        ...recordedSalary,
        matched: salaryMatch,
        salary: recorded_annual_salary,
      });
    }
    // }
  };

  const getkycDetails = () => {
    let userid = user?._id;
    if (user?.onfido_kyc_success) {
      //// console.log("kyc has been done");
      loadKycReport(userid);
    } else {
      //// console.log("kyc has  been done but result has not been fetched");
      getKycReport(userid);
    }
  };

  const loadKycReport = async (tenantid) => {
    await axiosInstance
      .get(
        `${process.env.REACT_APP_SERVER_URL}/tenants/getkycreport/${tenantid}`,
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        //// console.log(res);
        //toast.success("KYC Report Fetched");
        setUserKycInfo(res.data.kycuser);
      })
      .catch((err) => {
        //console.log(err);
        //toast.error("Kyc Report Not Fetched")
      });
  };

  const getKycReport = async (tenantid) => {
    if (haveValue(tenantid)) {
      let myInterval = setInterval(async () => {
        await axiosInstance
          .get(
            `${process.env.REACT_APP_SERVER_URL}/tenants/getkycstatus/${tenantid}`,
            {
              headers: {
                "Accept-Language": localStorage.getItem("i18nextLng"),
              },
            }
          )
          .then((res) => {
            ////  console.log(res);
            if (res.data.status === "success") {
              //toast.success("KYC Report Fetched")
              setUserKycInfo(res.data.kycuser);
              clearInterval(myInterval);
            } else {
              clearInterval(myInterval);
            }
          })
          .catch((err) => {
            clearInterval(myInterval);
          });
      }, 3000);
    }
  };

  const getAnalysisDetails = async (req, res) => {
    let userid = user?._id;

    let myInterval = setInterval(async () => {
      //console.log("interval started running");

      await axiosInstance
        .get(
          `${process.env.REACT_APP_SERVER_URL}/tenants/checkmyanalysis/${userid}`,
          { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
        )
        .then((res) => {
          //// console.log(res);
          clearInterval(myInterval);
          //// console.log("interval stopped");
          loadUser(userType);
        })
        .catch((err) => {
          clearInterval(myInterval);
          return;
        });
    }, 4000);
  };

  const loadOffers = async () => {
    let url = `${process.env.REACT_APP_SERVER_URL}/offers/`;
    await axiosInstance
      .get(url, {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      })
      .then((res) => {
        setLoading(false);
        //// console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        //console.log(err);
      });
  };

  const checkAllMatches = async () => {
    //console.log("CHECKALLMATCHES CALLED!")
    let fname = user?.fname.toString();
    let lname = user?.lname.toString();
    let newName = fname.split(" ");
    let newLname = lname.split(" ");

    let temp_fname = "";
    for (let i = 0; i < newName.length; i++) {
      newName[i] = newName[i]?.toLowerCase();
      temp_fname = temp_fname + newName[i];
    }

    let temp_lname = "";
    for (let i = 0; i < newLname.length; i++) {
      newLname[i] = newLname[i]?.toLowerCase();
      temp_lname = temp_lname + newLname[i];
    }

    let user_fullname = temp_fname + temp_lname;

    let kyc_fullname = "";
    if (
      (userKycInfo?.onfido_doc_data?.first_name,
      userKycInfo?.onfido_doc_data?.last_name)
    ) {
      let kyc_fname = userKycInfo?.onfido_doc_data?.first_name;
      let kyc_lname = userKycInfo?.onfido_doc_data?.last_name;

      let kycName = kyc_fname.split(" ");
      let kycLname = kyc_lname.split(" ");

      let temp_fname1 = "";
      for (let i = 0; i < newName.length; i++) {
        if (kycName[i]) {
          kycName[i] = kycName[i]?.toLowerCase();
          temp_fname1 = temp_fname1 + kycName[i];
        }
      }

      let temp_lname1 = "";
      for (let i = 0; i < newLname.length; i++) {
        if (kycLname[i]) {
          kycLname[i] = kycLname[i]?.toLowerCase();
          temp_lname1 = temp_lname1 + kycLname[i];
        }
      }

      kyc_fullname = temp_fname1 + temp_lname1;
    }
    if (user?.onfido_kyc_success == false) {
      setIdent_all(false);
      return false;
    }

    var kyc_nationality = "";
    if (userKycInfo?.onfido_doc_data?.nationality)
      kyc_nationality =
        userKycInfo?.onfido_doc_data?.nationality?.toLowerCase();

    setIdent_all(true);
    return true;
  };
  const fetchFileData = async () => {
    let userid = user?._id;
    const res = await fetchTenantDocs(userid);
    console.log(res);
    setTenantDocsDataOriginal(res.data.success_res.tenantDocs);
  };

  const handleDownloadDoc = async (url, filename) => {
    fetch(url).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);

        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filename;
        alink.click();
      });
    });
  };
  const handlePreviewDocument = (url) => {
    window.open(url, "blank");
  };
  const handleAccordionSelect = (eventKey) => {
    setCurrentActiveAccordion(parseInt(eventKey));
  };

  function CustomToggle({ children, eventKey, callback }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey)
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <a href={undefined} onClick={decoratedOnClick}>
        {isCurrentEventKey ? _t("hideDetails") : _t("showDetails")}
        {/* {children} */}
      </a>
    );
  }

  const handleAssignProperty = (property_id) => {
    if (haveValue(queryParameters.get("sharedprofileid"))) {
      navigate(
        `/assignProperty/${property_id}?sharedProfile=${queryParameters.get(
          "sharedprofileid"
        )}&step=0`
      );
    }
    if (queryParameters.get("agencylink")) {
      const getSharedId = sharedProfileProp[property_id];
      navigate(
        `/assignProperty/${property_id}?sharedProfile=${getSharedId}&step=0`
      );
    }
  };

  const [rentDoc, setRentDoc] = useState("");
  const [rentValFrom, setRentValFrom] = useState(0);
  useEffect(() => {
    if (haveValue(recordedSalary.salary)) {
      if (haveValue(rent_from_income)) {
        console.log("rent_from_income", rent_from_income);
        setRentDoc(rent_from_income);
      } else if (haveValue(user?.current_annual_income)) {
        setRentDoc("current_annual_income");
      } else if (haveValue(user?.itr_amount)) {
        console.log("itr_amount");
        setRentDoc("itr_amount");
      } else {
        console.log("recordedSalary");
        setRentDoc("recordedSalary");
      }
    }
  }, [rent_from_income, recordedSalary]);

  useEffect(() => {
    console.log(rentDoc);
    handleRentDocChange();
  }, [rentDoc, recordedSalary]);

  const handleRentDocChange = () => {
    if (rentDoc == "current_annual_income") {
      setRentValFrom(user?.current_annual_income);
    }
    if (rentDoc == "itr_amount") {
      setRentValFrom(user?.itr_amount);
    }
    if (rentDoc == "recordedSalary") {
      setRentValFrom(recordedSalary?.salary);
    }

    const data = {
      shared_profile_id: queryParameters.get("sharedprofileid"),
      agencylink: queryParameters.get("agencylink"),
      rent_from_income: rentDoc,
    };
    saveRentPercentage(data);
  };

  const handleDownloadReport = () => {
    setGenSummaryLoading(true);
    getDocumentAnalysis(user?._id)
      .then((res) => {
        console.log(res, "reportResHere");
        setGenSummaryLoading(false);

        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        setGenSummaryLoading(false);
      });
  };

  const handleRentPercSave = (e, val) => {
    setLoading(true);
    const data = {
      shared_profile_id: queryParameters.get("sharedprofileid") || null,
      agencylink: queryParameters.get("agencylink") || null,
      rent_percentage: val,
    };
    saveRentPercentage(data)
      .then((res) => {
        loadFullInfo();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleZipDown = (e) => {
    e.stopPropagation();
    setShowSpinner(true);
    getZipDocs(user?._id)
      .then((res) => {
        const nodeJSBuffer = res.data.images.data;
        const uint8Array = new Uint8Array(nodeJSBuffer);

        // Convert Uint8Array to ArrayBuffer
        const arrayBuffer = uint8Array.buffer;

        // Create a Blob
        const blob = new Blob([arrayBuffer], {
          type: "application/octet-stream",
        });

        // Create a download link
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "documents.zip";

        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
        setShowSpinner(false);
      })
      .catch((err) => {
        setShowSpinner(false);
        console.log(err);
      });
  };

  return (
    <>
      {showExperianDetails ? (
        <DefaulterCheck
          user={user}
          setShowExperianDetails={setShowExperianDetails}
        />
      ) : (
        <>
          <Accordion
            className="primaryaccordion mobile-tenant-profile-accordation "
            defaultActiveKey={currentActiveAccordion.toString()}
            onSelect={handleAccordionSelect}
          >
            <Accordion.Item
              eventKey="0"
              id="divToPrint"
              className="position-relative"
            >
              {/* {currentActiveAccordion.toString() != "0" && (
            <button
              className="btn btngreen position-absolute"
              style={{ left: "20%", top: "25%", zIndex: "10" }}
              onClick={handleDownloadReport}
            >
              {_t(
                "getDocSummary",
                "button to get doc summary on landlord side tenant profile open."
              )}
            </button>
          )} */}
              <div className="withdownloadbtn">
                <Accordion.Header className="primaryaccordion-header setaccordionhead ">
                  <div className="d-flex justify-content-between w-100 align-items-center score_profile_div">
                    <span className="maintitle">{_t("skorAndDetails")}</span>
                    {currentActiveAccordion.toString() != "0" &&
                      (() => {
                        const userScore =
                          user?.paymentScores?.creditScore?.value;
                        const shouldShowIeScore =
                          user?.ie_verified && user?.is_university;

                        const scoreValue = haveValue(userScore)
                          ? shouldShowIeScore
                            ? ieScore
                            : +userScore
                          : shouldShowIeScore
                          ? ieScore
                          : null;

                        if (!haveValue(scoreValue)) return null; // Hides the <span> entirely

                        return (
                          <span
                            className={`accordion_score ${
                              haveValue(scoreValue) ? "" : "no-score-heading"
                            }`}
                          >
                            {scoreValue}
                          </span>
                        );
                      })()}
                  </div>
                </Accordion.Header>

                {currentActiveAccordion.toString() === "0" &&
                  (() => {
                    const sharedId =
                      queryParameters.get("agencylink") ||
                      queryParameters.get("sharedprofileid");
                    const queryParam = haveValue(
                      queryParameters.get("agencylink")
                    )
                      ? `agencylink=${sharedId}`
                      : `sharedprofileid=${sharedId}`;

                    return (
                      <button
                        className="download_profile_btn downloadProfileBtn"
                        id="donwloadProfileBtn"
                        onClick={() =>
                          window.open(
                            `https://${process.env.REACT_APP_URL_NAME}/generatedReport/${sharedId}?${queryParam}`,
                            "_blank"
                          )
                        }
                      >
                        <svg
                          width="54"
                          height="54"
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="27" cy="27" r="27" fill="#A3EB64" />
                          <path
                            d="M22.0907 17.1836C20.7369 17.1836 19.6362 18.2843 19.6362 19.6381V23.32H22.0907V19.6381H30.7852L31.9089 20.7619V23.32H34.3635V20.7619C34.3635 20.1099 34.1065 19.4847 33.6463 19.0245L32.5225 17.9008C32.0623 17.4406 31.4372 17.1836 30.7852 17.1836H22.0907ZM31.9089 30.6836V34.3654H22.0907V30.6836H31.9089ZM34.3635 31.9109H35.5907C36.2696 31.9109 36.818 31.3624 36.818 30.6836V27.0018C36.818 25.6479 35.7173 24.5472 34.3635 24.5472H19.6362C18.2824 24.5472 17.1816 25.6479 17.1816 27.0018V30.6836C17.1816 31.3624 17.7301 31.9109 18.4089 31.9109H19.6362V34.3654C19.6362 35.7192 20.7369 36.82 22.0907 36.82H31.9089C33.2627 36.82 34.3635 35.7192 34.3635 34.3654V31.9109ZM33.7498 26.695C33.9939 26.695 34.2281 26.7919 34.4007 26.9646C34.5733 27.1372 34.6703 27.3713 34.6703 27.6154C34.6703 27.8595 34.5733 28.0937 34.4007 28.2663C34.2281 28.4389 33.9939 28.5359 33.7498 28.5359C33.5057 28.5359 33.2716 28.4389 33.099 28.2663C32.9263 28.0937 32.8294 27.8595 32.8294 27.6154C32.8294 27.3713 32.9263 27.1372 33.099 26.9646C33.2716 26.7919 33.5057 26.695 33.7498 26.695Z"
                            fill="#253837"
                          />
                        </svg>
                      </button>
                    );
                  })()}
              </div>
              <Accordion.Body className="primaryaccordion-body paddingTop0">
                <div className="tabs-box-pattern">
                  <div id="main-content">
                    <div id="page-container" className="tab-content">
                      <div
                        id="home"
                        className="tab-pane active padding-full-zero"
                      >
                        <div className="tabs-item d-block">
                          {/* START  */}

                          <div className="userscrollprofile-topbar">
                            {
                              <Row className="mx-0">
                                {user?.profile_completed && (
                                  // <>{isOpen && <TenantSkor user={user} />}</>
                                  <Col xl={6} className="mb-3">
                                    <>
                                      <div className="profile-summary border-pd  p-0 ">
                                        <h2 className="green-bg-heading">
                                          <div className="heading-icon-wrapper">
                                            <img
                                              className="heading-icon"
                                              src="/images/green-meter.svg"
                                              alt="icon"
                                            />
                                          </div>
                                          <span>{_t("skor")}</span>
                                        </h2>
                                        {haveValue(
                                          user?.paymentScores?.creditScore
                                            ?.value
                                        ) ||
                                        (user?.ie_verified &&
                                        user?.is_university
                                          ? user?.kyc_success
                                            ? haveValue(user?.paymentScores)
                                            : !haveValue(user?.paymentScores)
                                          : false) ? (
                                          <div>
                                            <ProfileScore
                                              creditScore={
                                                user?.ie_verified &&
                                                user?.is_university
                                                  ? ieScore
                                                  : user?.paymentScores
                                                      ?.creditScore?.value
                                              }
                                              rentScore={
                                                user?.rental_skor < 200
                                                  ? user?.rental_skor || 0
                                                  : 200
                                              }
                                            >
                                              <h1>
                                                {(user?.ie_verified &&
                                                user?.is_university
                                                  ? ieScore
                                                  : user?.paymentScores
                                                      ?.creditScore?.value) +
                                                  (user?.rental_skor || 0)}
                                              </h1>
                                            </ProfileScore>
                                            <div className="name-box-new">
                                              <h3 className="score-name scoreName">
                                                {haveValue(
                                                  user?.kyc_details
                                                    ?.userDataByProvider[0]
                                                    ?.accounts[0]?.holderName
                                                )
                                                  ? user?.kyc_details
                                                      ?.userDataByProvider[0]
                                                      ?.accounts[0]?.holderName
                                                  : `${user?.fname} ${user?.lname}`}
                                                {"*"}
                                              </h3>
                                              <div className="expiry-skor-date">
                                                <span>
                                                  {_t("createdOn")}:{" "}
                                                  {moment(
                                                    haveValue(
                                                      user?.bankVerificationDate
                                                    )
                                                      ? user?.bankVerificationDate
                                                      : user?.created_at
                                                  ).format("DD-MM-YYYY")}
                                                </span>
                                                <span>
                                                  {_t("validTill")}:{" "}
                                                  {moment(
                                                    haveValue(
                                                      user?.bankVerificationDate
                                                    )
                                                      ? user?.bankVerificationDate
                                                      : user?.created_at
                                                  )
                                                    .add(2, "months")
                                                    .format("DD-MM-YYYY")}
                                                </span>
                                              </div>
                                              <ul className="score-textgray">
                                                {user?.ie_verified &&
                                                user?.is_university &&
                                                !haveValue(
                                                  user?.paymentScores
                                                    ?.creditScore?.value
                                                ) ? (
                                                  <span>
                                                    *
                                                    {_t("skorBasedOnIEProfile")}{" "}
                                                  </span>
                                                ) : (
                                                  <span>
                                                    *
                                                    {_t(
                                                      "bankAccountUsedForScoring"
                                                    )}{" "}
                                                  </span>
                                                )}
                                              </ul>
                                            </div>
                                            <div className="totalIncomeWrapper">
                                              <CombinedIncome
                                                combinedIncome={combinedIncome}
                                                userIncome={userIncome}
                                                gurantorsIncome={
                                                  gurantorsIncome
                                                }
                                              />
                                            </div>
                                            {
                                              <>
                                                <div className="score-meter-capsule-wrapper">
                                                  <div className="d-flex justify-content-between align-items-end gap-1 effort-rate">
                                                    <span className="effort-rate-head">
                                                      {_t("effortRate")}
                                                    </span>
                                                    {/* <div style={{}}> */}

                                                    {/* </div> */}
                                                    {/* <span className="flex-1 dotted-border-b"></span> */}
                                                    <span className="effort-rate-percentage">
                                                      {effortObj?.effort_rate}%
                                                    </span>
                                                  </div>
                                                  <div className="effort-rate-slider">
                                                    <RentPercSlider
                                                      effortRatePecentage={
                                                        effortObj?.effort_rate
                                                      }
                                                      changeEffortRatePercentage={
                                                        handleRentPercSave
                                                      }
                                                      value={100}
                                                    />
                                                  </div>
                                                </div>

                                                <p className="d-flex justify-content-between align-items-center orange-note-box">
                                                  <span className="orange-note-head">
                                                    {_t("maximumRent")}
                                                  </span>
                                                  <span className="orange-note-price">
                                                    {!Number.isNaN(
                                                      Number(
                                                        effortObj?.effort_amount
                                                      )
                                                    )
                                                      ? Math.round(
                                                          Number(
                                                            effortObj.effort_amount
                                                          )
                                                        )
                                                      : 0}
                                                    €
                                                  </span>
                                                </p>
                                              </>
                                            }
                                          </div>
                                        ) : haveValue(
                                            effortObj?.effort_amount
                                          ) &&
                                          effortObj?.effort_amount != "N/A" ? (
                                          <>
                                            <div className="score-content-area">
                                              <p className="no-score-text">
                                                {_t("noSkorAvailable")}
                                              </p>
                                              <CombinedIncome
                                                combinedIncome={combinedIncome}
                                                userIncome={userIncome}
                                                gurantorsIncome={
                                                  gurantorsIncome
                                                }
                                              />
                                              <div className="score-detail-box">
                                                <EffortRateBar
                                                  effortObj={effortObj}
                                                  handleRentPercSave={
                                                    handleRentPercSave
                                                  }
                                                />
                                                {
                                                  <p className="d-flex justify-content-between align-items-center orange-note-box">
                                                    <span className="orange-note-head">
                                                      {_t("maximumRent")}
                                                    </span>
                                                    <span className="orange-note-price">
                                                      {!Number.isNaN(
                                                        Number(
                                                          effortObj?.effort_amount
                                                        )
                                                      )
                                                        ? Math.round(
                                                            Number(
                                                              effortObj.effort_amount
                                                            )
                                                          )
                                                        : 0}
                                                      €
                                                    </span>
                                                  </p>
                                                }
                                              </div>
                                            </div>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </>
                                  </Col>
                                )}
                                <Col xl={6} className="mb-3">
                                  <div className="profile-summary border-pd  p-0 ">
                                    <h2 className="green-bg-heading">
                                      <div className="heading-icon-wrapper">
                                        <img
                                          className="heading-icon"
                                          src="/images/document-icon.svg"
                                          alt="icon"
                                        />
                                      </div>
                                      <span>{_t("profileSummary")}</span>
                                    </h2>

                                    <p className="profile-summary-desc box-content-area">
                                      {haveValue(user?.profileSummary) &&
                                      haveValue(user?.profileSummaryEs) ? (
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: nl2ul(
                                              localStorage.getItem(
                                                "i18nextLng"
                                              ) == "es"
                                                ? user?.profileSummaryEs
                                                : user?.profileSummary
                                            ),
                                          }}
                                        />
                                      ) : (
                                        genSummaryLoading && (
                                          <p>
                                            {_t(
                                              "profileSummaryGenerationInProgress"
                                            )}
                                          </p>
                                        )
                                      )}
                                      {!haveValue(user?.profileSummary) &&
                                      tenantDocsData?.length == 0
                                        ? _t("profileSummaryNotGenerated")
                                        : ""}
                                      {(!haveValue(user?.profileSummary) ||
                                        !haveValue(user?.profileSummaryEs)) &&
                                      !genSummaryLoading &&
                                      tenantDocsData?.length > 0 ? (
                                        <div className="d-flex align-items-center justify-content-center">
                                          <button
                                            className="btn btnorange"
                                            onClick={handleDownloadReport}
                                          >
                                            {_t(
                                              "generateProfileSummary",
                                              "Button on LL side for old tt profiles having docs to generate report."
                                            )}
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </p>
                                  </div>
                                </Col>
                                <SummarySection
                                  user={user}
                                  setShowExperianDetails={
                                    setShowExperianDetails
                                  }
                                  ident_all={ident_all}
                                  recordedSalary={recordedSalary}
                                  haveGuarantor={haveGuarantor}
                                  rentDoc={rentDoc}
                                  setRentDoc={setRentDoc}
                                  rentPercentage={rentPercentage}
                                  setRentPercentage={setRentPercentage}
                                  rentValFrom={rentValFrom}
                                  isLandlord={true}
                                  landlord_user={landlord_user}
                                />

                                {/* {user?.rent_paid && (
                              <Col
                                xl={6}
                                className={`mb-3 ${
                                  landlord_user?.account_status != "approved" &&
                                  "blur-approved"
                                } `}
                              >
                                <div className="score-professional border-pd change_color_white landlordRentalDetails position-relative">
                                  <TenantRentalDetails
                                    user={user}
                                    isLandlord={true}
                                  />
                                  {landlord_user?.account_status !=
                                    "approved" && (
                                    <LandlordBlurApprove
                                      landlord_user={landlord_user}
                                    />
                                  )}
                                </div>
                              </Col>
                            )} */}

                                <ProfileInfoSection
                                  user={user}
                                  alpha3ToName={alpha3ToName}
                                  userKycInfo={userKycInfo}
                                  setShowPhoneVerificationdModal={(e) => {
                                    console.log(
                                      "Only Valid For Tenant Profile!"
                                    );
                                  }}
                                  handleRemoveGuarantor={(e) => {
                                    console.log(
                                      "Only Valid For Tenant Profile!"
                                    );
                                  }}
                                  handleGurantorModal={(e) => {
                                    console.log(
                                      "Only Valid For Tenant Profile!"
                                    );
                                  }}
                                  showActionPrompts={false}
                                  sharersData={fullinfo.sharersData ?? []}
                                  isLandlord={true}
                                  landlord_user={landlord_user}
                                />

                                <ProfessionalAcademicSection
                                  user={user}
                                  recordedSalary={recordedSalary}
                                  showActionPrompts={false}
                                  landlord_user={landlord_user}
                                  isLandlord={true}
                                  incomeSources={incomeSources}
                                  fullinfo={fullinfo}
                                  loadFullInfo={loadFullInfo}
                                  allowIncomeSourceChange={true}
                                  showIncomeHighlight={true}
                                  isGuarantor={isGuarantor}
                                />
                              </Row>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="1"
              mobile-accordation-box
              className="mobile-btn-accordation"
            >
              <Accordion.Header className="primaryaccordion-header setaccordionhead">
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <span className="maintitle">
                    {_t("documents")}
                    {showSpinner ? (
                      <Spinner className="view_document_spinner" />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        onClick={handleZipDown}
                      >
                        <path
                          d="M9 13.5L3.375 7.875L4.95 6.24375L7.875 9.16875V0H10.125V9.16875L13.05 6.24375L14.625 7.875L9 13.5ZM2.25 18C1.63125 18 1.10175 17.7799 0.6615 17.3396C0.22125 16.8994 0.00075 16.3695 0 15.75V12.375H2.25V15.75H15.75V12.375H18V15.75C18 16.3687 17.7799 16.8986 17.3396 17.3396C16.8994 17.7806 16.3695 18.0007 15.75 18H2.25Z"
                          fill="#EF7833"
                        />
                      </svg>
                    )}
                    <label className="">
                      <ul className="infodorpdown summarydropdum position-relative">
                        <li>
                          <button className="iconinfo guarantor_tooltip">
                            <MdInfoOutline />
                          </button>{" "}
                        </li>
                        <ul className="tooltip">
                          <li>{_t("pdfFilesOnly")}</li>
                          <li>{_t("eachFileSizeTenMBMax")}</li>
                          <li>{_t("tenDocumentsMax")}</li>
                        </ul>
                      </ul>
                    </label>
                  </span>
                  {currentActiveAccordion.toString() != "1" && (
                    <span className="submain">
                      {Array.isArray(tenantDocsData)
                        ? `${tenantDocsData.length} ${_t("documents")}`
                        : "  "}
                    </span>
                  )}
                </div>
              </Accordion.Header>
              <Accordion.Body className="primaryaccordion-body">
                <Row className="card-listing cardListing">
                  {tenantDocsData?.map((eachData, index) => (
                    <Col md={4} key={eachData?._id}>
                      <Card className="doc-history-card">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="videoframe">
                              {eachData?.file_name?.endsWith(".csv") ? (
                                <img
                                  style={{ objectFit: "contain" }}
                                  src="/images/csv-dummy.svg"
                                  alt=""
                                />
                              ) : (
                                <iframe
                                  src={`${process.env.REACT_APP_SERVER_URL}/uploads/${eachData?.file_name}`}
                                  scrolling="no"
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-8 ps-0">
                            <Card.Body className="ps-1">
                              <div className="listing-head">
                                <div className="head-block">
                                  <div
                                    className="leftbartext"
                                    style={{ maxWidth: "85%" }}
                                  >
                                    <h5 style={{ paddingTop: "0px" }}>
                                      {_t(eachData?.type, "", "fixed")}
                                    </h5>
                                  </div>
                                  {showTickOnDoc(eachData, user) && (
                                    <img
                                      src="/images/tick-new.svg"
                                      alt=""
                                      className="green-check-icon"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="clave-wrapper">
                                {eachData?.from == "clave" ? (
                                  // <img
                                  //   className="upload_doc_icons"
                                  //   src="/images/downloaded_clave.svg"
                                  //   alt=""
                                  // />
                                  <label className="doc-uploaded-from doc-uploaded">
                                    {_t("clavePin")}
                                  </label>
                                ) : (
                                  <label className="doc-uploaded-from doc-uploaded">
                                    {_t("uploaded")}
                                  </label>
                                  // <img
                                  //   className="upload_doc_icons"
                                  //   src="/images/downloaded_upload.svg"
                                  //   alt=""
                                  // />
                                )}
                              </div>
                              <div className="listing-foot">
                                <div className="d-flex icon-wrapper">
                                  {landlord_user?.account_status ==
                                    "approved" && (
                                    <VscEye
                                      onClick={(e) =>
                                        handlePreviewDocument(
                                          `${process.env.REACT_APP_SERVER_URL}/uploads/${eachData?.file_name}`
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                                  {landlord_user?.account_status ==
                                    "approved" && (
                                    <span
                                      className=""
                                      onClick={(e) =>
                                        handleDownloadDoc(
                                          `${process.env.REACT_APP_SERVER_URL}/uploads/${eachData?.file_name}`,
                                          eachData?.file_name
                                        )
                                      }
                                    >
                                      <RiDownloadLine
                                        style={{
                                          cursor: "pointer",
                                          color: "#000",
                                        }}
                                      />
                                    </span>
                                  )}
                                  <MdOutlineHistory
                                    onClick={() => {
                                      setDocHistoryPopup(false);
                                      setSelectedTypeForHistory(
                                        eachData?.type ?? null
                                      );
                                      setDocHistoryPopup(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                                <span>
                                  {moment(eachData?.created_at).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              </div>
                            </Card.Body>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Accordion.Body>
            </Accordion.Item>
            <DocHistoryPopup
              isOpen={docHistoryPopup}
              user={user}
              onClose={() => setDocHistoryPopup(false)}
              docName={selectedTypeForHistory}
              previousUploads={tenantDocsHistory?.[selectedTypeForHistory]}
              handlePreviewDocument={handlePreviewDocument}
            />
            {!isGuarantor && (
              <Accordion.Item eventKey="2">
                <Accordion.Header className="primaryaccordion-header setaccordionhead">
                  <div className="d-flex justify-content-between w-100 align-items-center">
                    <span className="maintitle">
                      {_t("linkedProperities")}{" "}
                    </span>
                    {currentActiveAccordion.toString() != "2" &&
                      !haveValue(fullinfo?.assigned_property_id) &&
                      !haveValue(
                        fullinfo?.assigned_property_id?.property_id
                      ) && (
                        <span className="submain">
                          {Array.isArray(defaultPropertyLink)
                            ? `${defaultPropertyLink.length} ${_t(
                                "properties"
                              )}`
                            : ""}
                        </span>
                      )}
                  </div>
                </Accordion.Header>
                <Accordion.Body className="primaryaccordion-body position-relative">
                  {haveValue(fullinfo?.assigned_property_id) &&
                  haveValue(fullinfo?.assigned_property_id?.property_id) ? (
                    <></>
                  ) : (
                    <Row className="card-listing mt-0">
                      <h4 className="titlebar_new">
                        {_t("addOrRemoveProperty")}
                      </h4>
                      <div className="link-property prime-selectmulti">
                        <ReactMultiSelectCheckboxes
                          key={JSON.stringify(defaultPropertyLink)}
                          isMulti
                          name="link_property"
                          id="link_property"
                          options={enhancedOptions}
                          className="basic-multi-select form-control link_prop_select"
                          classNamePrefix="select"
                          placeholderButtonLabel={selectBtn}
                          getDropdownButtonLabel={function getDropdownButtonLabel(
                            _ref3
                          ) {
                            return selectBtn;
                          }}
                          selectedOptions={defaultPropertyLink}
                          onChange={handlePropSelect}
                          defaultValue={defaultPropertyLink}
                        />

                        <button
                          type="button"
                          className="btn btngreen"
                          onClick={handleLinkProperty}
                          disabled={!haveValue(propertyLink)}
                        >
                          {_t("saveChanges")}
                        </button>
                      </div>
                    </Row>
                  )}

                  {properties.map((property) =>
                    haveValue(fullinfo?.assigned_property_id) &&
                    haveValue(fullinfo?.assigned_property_id?.property_id) ? (
                      fullinfo?.assigned_property_id?.property_id ==
                      property?._id ? (
                        <>
                          <div className="paymentdeailbar">
                            <div className="paymentdeailbarleft">
                              <h3>{`${property?.street} - ${
                                Number.isNaN(
                                  parseInt(property?.street_number, 10)
                                )
                                  ? "N/A"
                                  : String(
                                      parseInt(property?.street_number, 10)
                                    )
                              }, ${property.floor_number}-${
                                property.flat_number
                              }`}</h3>
                              <p>
                                {_t("stairway")}:{" "}
                                {haveValue(property.staircase)
                                  ? property.staircase
                                  : "-"}
                                , {_t("floorNumber")}:{" "}
                                {haveValue(property.floor_number)
                                  ? property.floor_number
                                  : "-"}
                              </p>
                            </div>
                            <div className="paymentdeailbarryt">
                              {/* <button
                          className="btngreen"
                          onClick={(e) => {
                            handleAssignProperty(property?._id);
                          }}
                        >
                          Assign Property
                        </button> */}
                              <div></div>
                              <div>
                                <p>
                                  {_t(
                                    "assigned",
                                    "Landlord viewing tenant profile"
                                  )}
                                </p>
                                <a
                                  href={undefined}
                                  onClick={(e) =>
                                    navigate(
                                      `/payment/details/${fullinfo?.assigned_property_id?._id}`
                                    )
                                  }
                                >
                                  {_t("viewPayments")}
                                </a>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )
                    ) : Array.isArray(linkedPropId) &&
                      linkedPropId.includes(property?._id) ? (
                      <>
                        <div className="paymentdeailbar">
                          <div className="paymentdeailbarleft">
                            <h3>{`${property?.street} - ${
                              Number.isNaN(
                                parseInt(property?.street_number, 10)
                              )
                                ? "N/A"
                                : String(parseInt(property?.street_number, 10))
                            }, ${property.floor_number}-${
                              property.flat_number
                            }`}</h3>
                            <p>
                              {_t("stairway")}:{" "}
                              {haveValue(property.staircase)
                                ? property.staircase
                                : "-"}
                              , {_t("floorNumber")}:{" "}
                              {haveValue(property.floor_number)
                                ? property.floor_number
                                : "-"}
                            </p>
                            <Accordion className="">
                              <Card className="show-details-card">
                                <Card.Header>
                                  <CustomToggle
                                    eventKey={property?._id}
                                  ></CustomToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={property?._id}>
                                  <Card.Body className="row">
                                    <div className="col-sm-6">
                                      <h5> {"stairway"}:</h5>
                                      <p>
                                        {haveValue(property.staircase)
                                          ? property.staircase
                                          : "-"}
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <h5> {"floorNumber"}:</h5>
                                      <p>
                                        {haveValue(property.floor_number)
                                          ? property.floor_number
                                          : "-"}
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <h5> {"appartment"}:</h5>
                                      <p>
                                        {haveValue(property.flat_number)
                                          ? property.flat_number
                                          : "-"}
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <h5> {"postCode"}:</h5>
                                      <p>
                                        {haveValue(property.postcode)
                                          ? property.postcode
                                          : "-"}
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <h5> {"municipality"}:</h5>
                                      <p>
                                        {haveValue(property.muncipality)
                                          ? property.muncipality
                                          : "-"}
                                      </p>
                                    </div>
                                    <div className="col-sm-6">
                                      <h5> {"province"}:</h5>
                                      <p>
                                        {haveValue(property.province)
                                          ? property.province
                                          : "-"}
                                      </p>
                                    </div>
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            </Accordion>
                          </div>
                          <div className="paymentdeailbarryt">
                            <button
                              onClick={(e) =>
                                handleUnlinkProperty(property?._id)
                              }
                              className="delete-link-btn"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="25"
                                viewBox="0 0 26 25"
                                fill="none"
                              >
                                <path
                                  d="M10.6 4.59756H15.4C15.4 3.97657 15.1471 3.38101 14.6971 2.9419C14.247 2.50279 13.6365 2.2561 13 2.2561C12.3635 2.2561 11.753 2.50279 11.3029 2.9419C10.8529 3.38101 10.6 3.97657 10.6 4.59756ZM8.8 4.59756C8.8 4.05946 8.90864 3.52663 9.11971 3.02949C9.33078 2.53235 9.64015 2.08064 10.0302 1.70015C10.4202 1.31965 10.8832 1.01783 11.3927 0.811908C11.9023 0.605987 12.4484 0.5 13 0.5C13.5516 0.5 14.0977 0.605987 14.6073 0.811908C15.1168 1.01783 15.5798 1.31965 15.9698 1.70015C16.3599 2.08064 16.6692 2.53235 16.8803 3.02949C17.0914 3.52663 17.2 4.05946 17.2 4.59756H24.1C24.3387 4.59756 24.5676 4.69007 24.7364 4.85474C24.9052 5.0194 25 5.24274 25 5.47561C25 5.70848 24.9052 5.93182 24.7364 6.09648C24.5676 6.26115 24.3387 6.35366 24.1 6.35366H22.516L21.112 20.5324C21.0043 21.6188 20.4857 22.6271 19.6572 23.3607C18.8288 24.0942 17.75 24.5004 16.6312 24.5H9.3688C8.25024 24.5001 7.17172 24.0938 6.34354 23.3603C5.51536 22.6268 4.99688 21.6186 4.8892 20.5324L3.484 6.35366H1.9C1.66131 6.35366 1.43239 6.26115 1.2636 6.09648C1.09482 5.93182 1 5.70848 1 5.47561C1 5.24274 1.09482 5.0194 1.2636 4.85474C1.43239 4.69007 1.66131 4.59756 1.9 4.59756H8.8ZM11.2 10.1585C11.2 9.92566 11.1052 9.70233 10.9364 9.53766C10.7676 9.373 10.5387 9.28049 10.3 9.28049C10.0613 9.28049 9.83239 9.373 9.6636 9.53766C9.49482 9.70233 9.4 9.92566 9.4 10.1585V18.939C9.4 19.1719 9.49482 19.3952 9.6636 19.5599C9.83239 19.7246 10.0613 19.8171 10.3 19.8171C10.5387 19.8171 10.7676 19.7246 10.9364 19.5599C11.1052 19.3952 11.2 19.1719 11.2 18.939V10.1585ZM15.7 9.28049C15.9387 9.28049 16.1676 9.373 16.3364 9.53766C16.5052 9.70233 16.6 9.92566 16.6 10.1585V18.939C16.6 19.1719 16.5052 19.3952 16.3364 19.5599C16.1676 19.7246 15.9387 19.8171 15.7 19.8171C15.4613 19.8171 15.2324 19.7246 15.0636 19.5599C14.8948 19.3952 14.8 19.1719 14.8 18.939V10.1585C14.8 9.92566 14.8948 9.70233 15.0636 9.53766C15.2324 9.373 15.4613 9.28049 15.7 9.28049ZM6.6808 20.3638C6.74552 21.0155 7.05669 21.6203 7.55364 22.0603C8.05059 22.5003 8.6977 22.744 9.3688 22.7439H16.6312C17.3023 22.744 17.9494 22.5003 18.4464 22.0603C18.9433 21.6203 19.2545 21.0155 19.3192 20.3638L20.7088 6.35366H5.2912L6.6808 20.3638Z"
                                  fill="#223635"
                                  stroke="#223635"
                                  stroke-width="0.7"
                                />
                              </svg>
                            </button>
                            <button
                              className="btngreen btn assign-btn"
                              onClick={(e) => {
                                handleAssignProperty(property?._id);
                              }}
                            >
                              {_t("assignProperty")}
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )
                  )}
                  {landlord_user?.account_status != "approved" && (
                    <LandlordBlurApprove landlord_user={landlord_user} />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
          <Modal
            show={showSummaryModal}
            onHide={(e) => {
              setShowSummaryModal(false);
              setSummaryData("");
            }}
            centered
            className="newmodalui asguarantor"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {_t(
                  "tenantDocSummary",
                  "On landlord side then tenant profile is opened and summaryn is presenter"
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{summaryData}</p>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default UserScoreProfile;
